import { FeatureFlag } from '@mews-commander/enums';
import { isCurrentEnterpriseResDiaryIntegrationEnabled } from '@mews-commander/legacy-entities/src/selectors';
import { TooltippedIcon, useTabs } from '@mews-commander/ui';
import { getFullName, useCommanderSelector } from '@mews-commander/utils';
import { compactArray } from '@mews/fp';
import { useFeatureFlag, useLocalizeEnum } from '@mews/framework';
import { CustomerProfileClassifications } from '@mews-commander/data-access';
import { useCustomerDetail } from '../queries/useCustomerDetail';
import { useGuestClassificationsSplit } from '../../../accounts/modules/accountMerge';

export const useCustomerDetailPage = (customerId: string) => {
    const le = useLocalizeEnum();

    const customer = useCustomerDetail({ customerId });
    const isContractingTabEnabled = useFeatureFlag(FeatureFlag.contractingCustomerProfileDocumentsEnabled);
    const isResDiaryEnabled = useCommanderSelector((state) => isCurrentEnterpriseResDiaryIntegrationEnabled(state, {}));

    const tabs = useTabs(
        '/$currentEnterpriseId/Customer/$id',
        compactArray([
            'Dashboard',
            'Detail',
            'Internals',
            isContractingTabEnabled ? 'Contracting' : null,
            'Payment',
            'Billing',
            'ActionLog',
            isResDiaryEnabled ? 'TableBookings' : null,
        ])
    );

    const fullName = getFullName(customer);
    const guestProfileClassifications = customer?.customerClassifications ?? ({} as CustomerProfileClassifications);

    const { first, second, rest } = useGuestClassificationsSplit({
        guestProfileClassifications,
        preserveOrder: true,
    });

    const icons = compactArray([first, second, ...rest]).map(({ enumValue, iconName }) => {
        return iconName != null ? (
            <TooltippedIcon
                key={enumValue}
                size="small"
                value={iconName}
                tooltip={le('CustomerClassifications', enumValue)}
            />
        ) : null;
    });

    return { tabs, fullName, imageId: customer?.imageId || undefined, icons };
};
